import React from "react";
import { Input, Form, Select, Button } from "antd";
import { UserOutlined, LockOutlined, TeamOutlined } from "@ant-design/icons";
import { Row, Col } from "reactstrap";
import TimezonePicker from "react-timezone";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { add_fact_step1 } from "../../Redux/actions";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import countries from "./country.json";
import { warning } from "../../Controllers/toast";
// const regionData =
//   "البرز~32|اردبیل~03|آذربایجان غربی~02|آذربایجان شرقی~01|بوشهر~06|چارمحال و بختیاری~08|اصفهان~04|فارس~14|گیلان~19|گلستان~27|همدان~24|هرمزگان~23|ایلام~05|کرمان~15|کرمانشاه~17|خراسان جنوبی~29|خراسان رضوی~30|خراسان شمالی~61|خوزستان~10|کهگلویه و بویر احمد~18|کردستان~16|لرستان~20|مرکزی~22|مازندران~21|قزوین~28|قم~26|سمنان~12|سیستان و بلوچستان~13|تهران~07|یزد~25|زنجان~11";
// CountryRegionData[104][2]=regionData

const { Option } = Select;
const layout = {
  labelCol: {
    span: 12,
  },
  wrapperCol: {
    span: 24,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 0,
    span: 24,
  },
};

const Step1_Add = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const add_fact = useSelector((state) => state.add_fact_step1);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  // console.log(add_fact, "is add_fact");

  const onFinish = (value) => {
    // console.log(value);
    dispatch(add_fact_step1(value));

    // form.resetFields();
    if (props.page) {
      props.setData(value);
    } else {
      props.validation(true);
      props.data(value, "step1");
    }
  };
  const onFinishFailed = (err) => {
    warning(lang_choiced.pages.add_fact.rules.warnCorrectEnterValue);
    // console.log(err);
  };
  const powerUnitSelector = (
    <Form.Item
      name="fact_power_unit"
      initialValue={add_fact.fact_power_unit}
      noStyle
      rules={[
        {
          required: true,
          message: lang_choiced.pages.add_fact.rules.fact_power_unit,
        },
      ]}
    >
      <Select
        // name="fact_power_unit"

        style={{
          width: 70,
        }}
      >
        <Option value="kW">kW</Option>
        <Option value="MW">MW</Option>
      </Select>
    </Form.Item>
  );
  return (
    <Form
      form={form}
      name="addFactory"
      initialValues={
        add_fact
          ? {
              contractor: add_fact.contractor,
              privacy: add_fact.privacy,
              mag: add_fact.mag,
              fact_timezone: add_fact.fact_timezone,
              fact_power_unit: add_fact.power,
              fact_name: add_fact.fact_name,
              fact_address: add_fact.fact_address,
              fact_country: add_fact.fact_country,
              fact_state: add_fact.fact_state,
              fact_city: add_fact.fact_city,
              fact_post_code: add_fact.fact_post_code,
              fact_power_name: add_fact.fact_power_name,
              fact_tel: add_fact.fact_tel,
            }
          : {
              contractor: false,
              privacy: false,
              mag: false,
              fact_timezone: "",
              fact_power_unit: "kW",
              fact_name: "",
              fact_address: "",
              fact_country: "",
              fact_state: "",
              fact_city: "",
              fact_post_code: "",
              fact_power_name: "",
              fact_tel: "",
            }
      }
      {...layout}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      // labelCol={{span:24 , offset:17 , }}
      // labelAlign="left"
      layout="vertical"
    >
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <TeamOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_name}
          </span>
        }
        name="fact_name"
        key="fact_name"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_name,
          },
        ]}
      >
        <Input className="login-form-style " size="large" type="text" />
      </Form.Item>

      <Form.Item
        {...tailLayout}
        label={
          <span>
            <UserOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_country}
          </span>
        }
        name="fact_country"
        key="fact_country"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_country,
          },
        ]}
      >
        {/* <CountryDropdown
          priorityOptions={["IR", "IQ", "AE"]}
          blacklist={["IL"]}
          value={"fact_country"}
          onChange={(val) => {
            // console.log(val)
            setCountrySelector(val);
          }}
          className="login-form-style "
          style={{ width: "100%", height: "40px" }}
        /> */}
        <Select>
          {countries.map((country) => (
            <Option key={country.alpha_3_code} value={country.alpha_3_code}>
              {window.localStorage.getItem("lang") === "persian"
                ? country.name_fa
                : country.name_en}
            </Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_state}
          </span>
        }
        name="fact_state"
        key="fact_state"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_state,
          },
        ]}
      >
        <Input className="login-form-style " size="large" />
      </Form.Item>

      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_city}
          </span>
        }
        name="fact_city"
        key="fact_city"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_city,
          },
        ]}
      >
        <Input className="login-form-style " size="large" />
      </Form.Item>
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <TeamOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_address}
          </span>
        }
        name="fact_address"
        key="fact_address"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_address,
          },
        ]}
      >
        <Input className="login-form-style " size="large" type="text" />
      </Form.Item>
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style input-ltr" />
            {lang_choiced.pages.add_fact.step1.forms.fact_post_code}
          </span>
        }
        name="fact_post_code"
        key="fact_post_code"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_post_code,
          },
        ]}
      >
        <Input className="login-form-style " size="large" />
      </Form.Item>
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_power_name}
          </span>
        }
        name="fact_power_name"
        key="fact_power_name"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_power_name,
          },
        ]}
      >
        <Input
          className="login-form-style"
          size="large"
          type="integer"
          addonAfter={powerUnitSelector}
          min={0}
        />
      </Form.Item>
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style input-ltr" />
            {lang_choiced.pages.add_fact.step1.forms.fact_tel}
          </span>
        }
        name="fact_tel"
        key="fact_tel"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_tel,
          },
        ]}
      >
        <Input type="tel" className="login-form-style " size="large" />
      </Form.Item>
      <Form.Item
        {...tailLayout}
        label={
          <span>
            <LockOutlined className="Icon-style" />
            {lang_choiced.pages.add_fact.step1.forms.fact_timezone}
          </span>
        }
        name="fact_timezone"
        key="fact_timezone"
        rules={[
          {
            required: true,
            message: lang_choiced.pages.add_fact.rules.fact_timezone,
          },
        ]}
      >
        <TimezonePicker
          style={{ width: "100%" }}
          className="login-form-style "
          value="timezone"
          // onChange={(timezone) =>
          //   console.log("New Timezone Selected:", timezone)
          // }
          inputProps={{
            placeholder: "",
            name: "timezone",
          }}
        />
      </Form.Item>
      <Form.Item>
        <Row style={{ textAlign: "right" }}>
          <Col sm={12} xs={12} md={12} lg={12} xl={12}>
            <Button
              type="primary"
              className=" login-button p-2"
              htmlType="submit"
              style={{ width: "auto", fontSize: 15 }}
            >
              {props.page
                ? lang_choiced.pages.add_fact.btnChange
                : lang_choiced.pages.add_fact.btnNext}
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default Step1_Add;
